(function () {
  // English language file www.lorinthe.com website

  // @Author: Tom Voorneveld <root>
  // @Date:   2016-10-17T15:01:53+02:00
  // @Email:  tom@lorinthe.com
  // @Project: Lorinthe
  // @Last modified by:   tom
  // @Last modified time: 2018-11-13T23:21:13+01:00
  // @License: Copyright Lorinthe BV, The Netherlands. All rights reserved
  module.exports = {
    title: {
      alt: 'Lorinthe B.V. The Netherlands',
      punchline: 'executive advisory',
      subtext: ''
    },
    intro: {
      payload: 'At Lorinthe we uniquely combine strong <i>information technology knowledge</i>, <i>commercial talent</i> and <i>personal empathy</i>. <br><br>Our expertise enables us to develop the <i>best solutions</i> for your <i>IT related business problems.</i>.',
      expert_title: 'Our focus',
      list_expert: {
        1: 'business <b>development</b>',
        2: 'marketing <b>strategy</b>',
        3: 'service design',
        4: 'for IT companies & services'
      },
      problems_title: 'Problems we solve',
      problems_list: {
        1: 'confusing portfolio; <b>increase cross-selling</b>?',
        2: 'price pressure; how to <b>differentiate</b>.?',
        3: 'security concerns; how to <b>convince</b> your clients?',
        4: 'version management; prevent duplicate work',
        5: 'development focus; set <b>priorities</b>',
        6: 'resilience; <b>prepare</b> for economic downturns',
        7: '<b>open source</b> strategy; ignore, fight, join',
        8: 'state management; avoid data duplication'
      },
      problems_tooltip: {
        1: 'Do your clients take your complete family of services? Can we increase cross-selling to maximise revenue per client?',
        2: 'When your product or service becomes a commodity, how can keep your margins?',
        3: 'You know your product is the most secure.. but does your client believe you?',
        4: 'Can you serve multiple target groups with just one code base?',
        5: 'In an agile world, you can be crazy busy each day. But how to set commercial priorities that are not overwhelmed by the hectic of the day?',
        6: 'Repairing the roof when the sun shines... do we need to say more?',
        7: 'Are you paying fair amounts for the software you use? Can you reduce your license cost? Can you reduce maintenance costs for your software? How do you stay in control?',
        8: 'How much does it cost to maintain multiple data sources? Can we introduce "one source of truth"?'
      }
    },
    services: {
      label: 'services',
      title: 'Advisory Services',
      header: 'Our sensible Expertise',
      payload: 'solution development & problem solving',
      slot: 'Lorinthe is able to offer the main advisory services to aid your business and resolve your problems. Regardless of how you engage us, we understand what a small business or new project requires. We possess the experience and ability to provide industry best-practices.',
      prices: {
        title: 'Quotation',
        incentive: 'Please have a look at our price structure'
      },
      subtitle: 'The activities we offer on project or hourly basis',
      1: {
        img: 'userstories.jpg',
        label: 'scenarios',
        title: 'Empathy',
        caption: 'Your clients are people - so we treat them as such.',
        slot: '<b>User Stories or Scenarios</b> describe in detail what users do on a website and <b>why</b>. A user scenario is like a short story of a person who uses the app with a certain motivation and a specific goal in mind.<br/><br/>We need this information as it is utterly important that our developers <b>understand</b> you, avoid a "code-and-fix-again" traps.',
        block: 'Example of a User Story: As a sailor, I want to have all the information about the regatta on my phone, so that I don’t loose any time at sea.'
      },
      2: {
        img: 'wireframes.jpg',
        label: 'wireframes',
        title: 'Sketch, design, develop',
        caption: 'It\'s all in the eye of the beholder.',
        slot: ' It’s easy to come up with the idea, but the hard part is understanding how that idea will take shape. This is where we need to sketch. Some companies propose three steps: sketching, wire-frame design and creation of mockups, sometimes even interactive.<br/><br/>To avoid the work-duplication that this introduces, we suggest to use one method only. We could suggest open source technology so your users can join the process while keeping cost down.',
        block: 'Leonardo Da Vinci sketched all of his inventions, they still serve a purpose'
      },
      3: {
        img: 'pwa.jpg',
        label: 'development',
        title: 'Step by step',
        caption: 'Layer by layer we dive deeper.',
        slot: 'While a solution to a problem might come from a revelation, the actual development is layered process where we go deeper and deeper until we both know what to do. ',
        block: 'Maybe a Progressive Web App would do the job just fine? It cost only ten percent of creating multiple native apps for all platforms. Would it suit your users?'
      },
      4: {
        img: 'qa-and-deployment.jpg',
        label: 'testing',
        title: 'Quality means Testing',
        caption: 'You need proof for all you can get.',
        slot: 'We need to make sure that new products work as intended. Did you consider maybe some kind of <b>alpha test</b>? It is the first testing of the complete end-to-end application. You can then objectively measure usability, comparing it to other apps and the user expectation.',
        block: 'A quality product delivered to the customers helps in gaining their confidence from day one.'
      }
    },
    cases: {
      label: 'cases',
      title: 'case studies',
      payload: 'We developed & contributed to hundreds of business challenges. To list a few:',
      1: {
        label: 'lorinthe',
        title: 'Lorinthe.com',
        img: 'lorinthe.jpg',
        header: 'Progressive Web',
        intro: 'How to stand out from other websites? We developed not ordinary website but a "progressive web app"! This page should load fast, even with shaky Internet',
        chapter: {
          1: {
            title: 'Google Lighthouse',
            payload: 'Google provides us with a tool called "Lighthouse" to measure web apps against a set of rules. Here are the latest results of www.lorinthe.com, the site you are currently looking at:',
            img: 'pwa-lorinthe-v3.png',
            quote: 'Fast and minimalist, the user experience is primary'
          },
          2: {
            title: 'Test your own site',
            payload: 'We would recommend to test your own website as well. You will have to use Chrome as web browser but then anyone can measure the progressive performance of any site: <br><br><a href="https://developers.google.com/web/tools/lighthouse/" class="btn btn-warning" target="_blank">Measure your own website on Google Lighthouse</a>'
          }
        }
      },
      2: {
        label: 'hepicon',
        title: 'Hepicon',
        img: 'hepicon.jpg',
        header: 'Health Professionals',
        intro: 'With more than 1000 members Hepicon became the most proficient closed social network for health care professionals in rheumatology.',
        chapter: {
          1: {
            title: 'Self Expression',
            payload: 'The professionals have space for self-expression, knowledge-gathering and knowledge-sharing. A "dashboard", the home page, presents news, studies, discussion groups, the status of friends and much more. Colleagues from all specialties and platforms share their expertise in different groups. It discusses cases, publishes studies and evaluate new developments in expert panels or discussion groups.',
            img: 'hepicon-iphone.jpg',
            quote: 'In the five years that we built Hepicon, we learned how professionals and care takers interact with each other. What works and what does not work... '
          },
          2: {
            title: 'Closed',
            payload: 'We developed Hepicon as <b>the</b> on-line platform for communication among rheumatology care professionals. It\'s a strictly closed platform: only members can access the domain.'
          }
        }
      },
      3: {
        label: 'qrespi',
        title: 'Shared Web Browsing',
        img: 'qrespi-coach.jpg',
        header: 'Connect to Care',
        intro: 'A deskstand with an on-line application for family to remotely support seniors.',
        chapter: {
          1: {
            title: '',
            payload: 'For example, you can use Qrespi to support grandparents with on-line shopping. For a smooth experience,  seniors use a special designed desk stand that holds a tablet. The tablet has only one screen showing video calling and a remote browser.'
          },
          2: {
            title: 'Mockup',
            payload: 'We are working to launch Qrespi in 2018 as we already realized a lot of work. A mock-up shows our goal:',
            // img: ''
            embed: {
              src: 'img/cases/qrespi-framework-v03.svg',
              caption: 'Click to flip through the slides<br/><br/>or use &larr; &rarr; buttons<br/><br/>press "i" to see an overview.'
            }
          }
        }
      },
      // quote: ''
      4: {
        label: 'zvs',
        title: 'ZVS',
        img: 'zvs.jpg',
        header: 'Care Tracking',
        intro: 'Advanced Care Tracking system designed to allow both professionals as well as patients track the progress of their, often chronic, deceases.',
        chapter: {
          1: {
            title: 'Continuous improvement',
            payload: 'Especially with the group of patients that have chronic deceases, there is a continuous need to help patients with their live. As on-site consult is expensive, we allow patients to share the development of their decease with the clinic. Medical staff can more efficiently work together on this information as a strong alert notification system helps to decide who should see what and no more than that.',
            img: 'zvs-overview.jpg'
          },
          2: {
            title: 'Secure',
            payload: 'Answering to the growing concern of consumers about their privacy,  governmental regulations stipulate exactly what we can, and more often what we can not do with patient data. For obvious reasons, it is the organization\'s IT department that is concerned as they carry the main responsibility. To accommodate their concerns, Lorinthe developed an unique "Social Anonymizer", a tool that basically removes all patient\'s name, address and numbers from our databases and only allows them within the browser of the doctor in the hospital. We combine the benefits from the internal IT security as well as the great price performance ratios of the cloud!',
            quote: 'While our patient portal served its purpose for some years, only now we see the benefits of true interaction.'
          }
        }
      },
      5: {
        label: 'ufollow_us',
        title: 'uFollow.us',
        img: 'uf-truck.jpg',
        header: 'IOT Integrations',
        intro: 'uFollow.us <i>[`You-follow-us`]</i> connects messaging apps with third-party services and devices to form an "Internet of Things" network.',
        chapter: {
          1: {
            title: 'Follow me',
            payload: 'uFollow.us is an excellent tracking and sharing tool for professionals, business-partners, groups and teams. uFollow.us is very efficient as we use ordinary messaging apps for notifications and communication. uFollow.us connects to our own Transponder App or to any third-party service and device you might like to connect.',
            img: 'ufollowus-workflow.svg'
          },
          2: {
            title: 'Total solution for mobile people',
            payload: 'uFollow.us enhances the functionality of messaging apps with so called "features" or "integrations". Integrations are on-line service programs that connect and interact within chat channels. For example, Qrespi has integrations that can automatically provide a response after a certain trigger. This trigger can generate quotations, execute sales polls, geo-track staff location, book events, announce new sales documentation and so much more.'
          }
        }
      }
    },
    state: {
      title: 'Truly hands-on',
      intro: 'We have been there and by first hand experienced the pitfalls in IT business:<br><br>"<i>From falling we learn to stand up</i>".'
    },
    technology: {
      label: 'technology',
      header: {
        title: 'Technology',
        subtitle: 'The challenge',
        lead: 'informed intuition | abundant experience'
      },
      choices: {
        title: 'The choices we make',
        payload: 'When developing apps, one of the biggest challenges is to choose the best programming <b>libraries</b> and <b>frameworks</b>. Our success in this challenge is one of our biggest assets.<br/><br/>Please note <b>this is a dynamic list</b>; preferences change over time due to market situations and development. '
      },
      1: {
        label: 'Web Apps',
        icon: 'mobile',
        title: 'Web Apps',
        slot: '"A web application is a computer program that utilizes web browsers and web technology to perform tasks over the Internet." An important advantage of this approach is that developers will no longer need to develop multiple apps across multiple platforms. Even for those who develop only for iOS and Android, this means huge savings in time and effort. ',
        plus: {
          1: 'one code base for all platforms',
          2: 'mobile first',
          3: 'excellent performance',
          4: 'responsive design',
          5: 'no memory waste for install',
          6: 'shared with url',
          7: 'still distribute in App/Play Stores',
          8: 'automatic updates'
        }
      },
      2: {
        label: 'PWA',
        icon: 'retweet',
        title: 'Progressive Web Apps',
        slot: 'A Progressive Web App are webapps that are capable of providing similar functionality and <b>seamless user interface</b> found in the best native apps; an experience that was previously hard to provide. It\'s important to realize that PWA\'s are <b>not hybrid</b> apps! Hybrid apps depend on an intermediate, non-standard, layer between the app and the device. This will lead to a <b>locked-in</b> development process.<br/><br/>Please read what Google has to say about <a href="https://developers.google.com/web/progressive-web-apps/" target="_blank">Progressive Web Apps</a>.',
        block: 'We expect that progressive web apps are the next big thing for the mobile web. It attracts a lot of attention because of the relative ease of development and almost instant wins for the application’s user experience.',
        plus: {
          1: '"progressive": instant loading',
          2: 'push notifications (native mobile)',
          3: 'keeps running off-line',
          4: 'fast',
          5: 'home screen icons on Android',
          6: 'various mobile hardware interfaces',
          7: 'approaching native apps'
        }
      },
      3: {
        label: 'Vue.js',
        icon: 'code',
        title: 'VueJS Front-End Framework',
        slot: 'Vue.js is, let\'s face it, a <b>kick ass framework</b>. And it isn\'t just about writing great code. You need excellent documentation, a strong community helping each other learn, a supporting cast of libraries and plug-ins to help users solve the hard problems, and short feedback loops based on user feedback to keep the framework relevant. Vue.js is all of that, plus great code. That\'s why we\'re using it.',
        block: 'As a front-end web developer, I get to work with awesome people in workplace and get feedback for my ideas in the greater developer community. I love front-end development... and Vue.js!',
        image: 'vuejs.svg',
        plus: {
          1: 'templating - access .js with {{}}',
          2: 'reactivity - all automatic UI updates',
          3: 'components - encapsulate behavior',
          4: 'use standard ES6 JavaScript rules(!)'
        }
      },
      4: {
        label: 'State',
        icon: 'table',
        title: 'State Management',
        slot: 'Although the basic concept is as old as the way to Rome, <i>state management</i> in front-end software has been neglected for a long time. Now, since a few years, it\'s back and better than ever. <br/><br/>Basically, a "state" is  "one source of truth" for all activity in the front end. All logic, including the back-end server, <i>only</i> communicates by the <i>state</i>. This difference is not so visible with only a few components but very impressive when the number of inter-connections grow. No longer we accept deep links or so called "AJAX call spaghetti"... Refreshing!!',
        block: 'State-Management allows Lorinthe to focus on the User Interface. A well documented state-container connects to other parts of the application. It allows other software developers to concentrate on application logic and outsource the tedious UI work.',
        image: 'state-management.svg',
        plus: {
          1: 'Maintain the state of your UI such as keeping the sidebar opened or closed when changing routes.',
          2: 'Control the UI from any point of the application without worrying about how components are related or how to inject a specific service.',
          3: 'Chain UI layout-specific actions with other events such as saving data server-side or changing a route'
        }
      },
      5: {
        label: 'Node.js',
        icon: 'file-code-o',
        title: 'Node.js - server side JavaScript',
        slot: 'JavaScript is the language for adding interactivity to a website, but there\'s so much more it can do. Enter Node.js and Express.js, two technologies that extend the capabilities of JavaScript. The Node platform allows you to develop <b>server</b>-side applications with JavaScript that you can then easily publish as websites with the Express framework.',
        block: 'I\'m constantly and pleasantly surprised that for whatever little tool or demonstration I need, no matter how complex, Node.js greatly simplifies my life!',
        image: 'node.svg',
        plus: {
          1: 'one language for both server and client',
          2: 'high performance',
          3: 'easy to scale',
          4: 'fast delivery',
          5: 'sublime npm package management'
        }
      },
      6: {
        label: 'Realtime DB',
        icon: 'database',
        title: 'Open-source databases for the realtime web',
        slot: 'Only a few years ago, database work was among the most boring of tasks in IT -- in a good way. Data went into one of the major SQL databases and it came out later, all in one piece, exactly as it went in. The database creators had succeeded in delivering rock-solid performance, and everyone started taking it for granted.<br/><br/>Then the nature of what we wanted to store changed. Databases had to move beyond bank accounts and airline tickets because everyone had begun sharing data on social networks. Suddenly there was much more data to store, and most of this new data didn’t fit into the old tables. The work of database admins and creators transformed, and what has emerged is a wide array of intriguing solutions that help to make databases among the more intriguing technologies today.',
        block: 'Lorinthe specializes in these modern databases: it is a pleasure to work with them and the end result is fast and flexible.',
        plus: {
          1: 'RethinkDB',
          2: 'MongoDB',
          3: '... and others'
        }
      },
      7: {
        label: 'Nginx',
        icon: 'server',
        title: 'Nginx Web and Proxy Server',
        slot: 'Nginx is a free, open-source, high-performance HTTP server. It is suited not only for web serving but also for reverse proxying, caching, load balancing, media streaming, and more.',
        block: 'We use Nginx in many of our PWA related projects for the simple fact that is creates a simple but very effective high availability setup in just minutes. ',
        plus: {
          1: 'high performance',
          2: 'stability',
          3: 'rich feature set',
          4: 'simple configuration',
          5: 'low resource consumption'
        }
      },
      8: {
        label: 'Docker',
        icon: 'rocket',
        title: 'Docker',
        slot: 'Docker containers wrap a piece of software in a complete filesystem that contains everything needed to run: code, runtime, system tools, system libraries – anything that can be installed on a server. This guarantees that the software will always run the same, regardless of its environment.<br/>Docker provides this same capability without the overhead of a virtual machine. It lets you put your environment and configuration into code and deploy it. <br/>Lorinthe will help you to set up and maintain your containers.',
        block: 'Docker containers provide consistency in the turbulent world of software development environments.',
        plus: {
          1: 'Standardization & productivity',
          2: 'Compatibility & maintainability',
          3: 'Simplicity & faster configurations',
          4: 'Rapid Deployment',
          5: 'Isolation & Security'
        }
      },
      9: {
        label: 'Linux',
        icon: 'linux',
        title: 'Ubuntu & Linux based operating systems',
        slot: 'Ubuntu is a Debian-based Linux operating system for personal computers, tablets and smartphones. Since 2008 we have been working <b>exclusively</b> with this OS. <b>Everybody</b> in the company, from developers to secretaries, use any other OS. <br/><br/>Not all Windows or Mac applications run on Ubuntu but there are always good alternatives or better even: <b>cloud-based solutions</b>. The baker eats his own bread;)',
        block: 'We <b>all love Ubuntu!</b>. It\'s very productive, secure, fast and a daily pleasure to use.',
        image: 'ubuntu.svg',
        plus: {
          1: 'open source',
          2: 'secure - no virus avalanche',
          3: 'versatile',
          4: 'stable - stable - stable',
          5: 'compact - still runs fast on older hardware'
        }
      },
      10: {
        label: 'Chat',
        icon: 'telegram',
        title: 'Messaging Apps as the new Operating System?',
        slot: 'Chat apps became the enabler of all kind of services as a natural extension of our everyday toolbox. Lorinthe has abundant experience and developed a versatile <b>chat integration platform</b>.',
        block: 'Contact us and we can discuss how we can connect your service within a fast and effective messaging app infrastructure.',
        image: 'qrespi-workflow.svg',
        plus: {
          1: 'omni-present: we all use it',
          2: 'fast',
          3: 'direct',
          4: 'FREE'
        }
      },
      11: {
        label: 'Trello',
        icon: 'trello',
        title: 'Trello - Project management',
        slot: 'Trello is an awesome project management tool that makes collaboration easy and, dare we say, even fun. On top of the project management, this visual list tool can do so much more, whether you\'re organizing work projects, family chores, travel plans, or just about anything else.<br/>We like it, as Trello has everything you need to organize projects of any size. However we can use any project management tool or bug tracker.',
        block: 'Man, I love Trello. It’s a free, easy-to-use, collaborative, and highly visual tool with more than 10 million users around the world. I use it to help organize both my personal and professional life',
        plus: {
          1: 'boards; one board per project',
          2: 'lists; each suggesting a stage',
          3: 'cards; order sets priority',
          4: 'FREE'
        }
      },
      12: {
        label: 'Agile',
        icon: 'stethoscope',
        title: 'Agile Project Management',
        slot: 'Agile methods grew out of the real-life project experiences of leading software professionals who had experienced the challenges and limitations of traditional waterfall development on project after project. The approach promoted by agile development is in direct response to the issue associated with traditional software development both in terms of overall philosophy as well as specific processes.',
        block: 'We believe in short cycles with immediate results, which we can test... every day.',
        image: 'scrum_process.svg',
        plus: {
          1: 'Stakeholder Engagement',
          2: 'Transparency',
          3: 'Early and Predictable Delivery',
          4: 'Predictable Costs and Schedule',
          5: 'Allows for Change',
          6: 'Focuses on Business Value',
          7: 'Focuses on Users'
        }
      }
    },
    clients: {
      title: '100+ clients',
      payload: 'While we are not at liberty to say exactly what we did, we can list a few assignments:',
      link: '',
      seals: {
        1: 'pfizer.svg',
        2: 'maasstad.png',
        3: 'ucb.png',
        4: 'stork.svg',
        5: 'wyeth.png',
        6: 'roche.svg',
        7: 'kraft_heinz.png',
        8: 'logica_cmg.svg',
        9: 'atf-logo.svg',
        10: 'alpha-test-group.svg',
        11: 'ys_inc.svg',
        12: 'venvn.svg',
        13: 'qrespi.svg',
        14: 'artsennet.gif',
        15: 'hepicon.svg',
        16: 'ciklum.svg'
      }
    },
    testimonial: {
      title: 'they are saying',
      1: 'It made a real difference in how we envision our future!',
      2: 'We believe that our employees stay longer with the company now we have a clear commercial strategy.',
      3: 'With a complete new service designed, we increased our revenue.',
      4: 'Combining service work and product sales became possible by some brave positioning choices.'
    },
    contact: {
      label: 'contact',
      title: 'contact us',
      caption: 'Send us a message, we will reply as soon as we can.',
      name: {
        label: 'Your name:'
      },
      salutation: 'salutation',
      firstname: {
        placeholder: 'First name'
      },
      lastname: {
        placeholder: 'Last name'
      },
      email: {
        label: 'Email address:',
        placeholder: 'you@domain.com',
        description: 'We will never share your email with anyone else.'
      },
      topic: {
        label: 'Topic',
        placeholder: 'Please select one topic',
        description: '',
        list: {
          1: 'Possible assignment for problem solving',
          2: 'Keynote presentation',
          3: 'Career',
          4: 'Press contact',
          5: 'Other'
        }
      },
      message: {
        label: 'Message',
        placeholder: 'Your message here...',
        description: ''
      },
      socialmedia: {
        share: 'Share this page',
        follow: '...or follow us on:',
        twitter: '@lorinthe'
      }
    },
    responseform: {
      title: 'Contact form',
      ok: 'Thank you! We will get back to you as soon as possible.',
      failed: 'Sorry, something went wrong with the submission of your form ...',
      both: 'You can also send us an <b><a href=\'mailto:moreinfo@lorinthe.com?subject=Lorinthe Contact Request\'>email</a></b>  '
    },
    solutions: {
      label: 'solutions',
      title: 'Lorinthe Solutions',
      description: '<p>Our clients are small and medium sized companies. We usually work on the executive level. We speak the language of IT as well though: development projects, testing, deployment, as we digital services are the core of so many enterprises today.</p>'
    },
    // prices:
    // label: 'prices'
    // title: 'Lorinthe Services'
    // subtitle: 'We specialize in providing you modern IT services'
    // slot: '<h3>Functionality Enhancement</h3><p>.</p>'
    // table:
    //   title: 'Service Overview'
    //   slot: '<p>Lorinthe has developed special expertise in the field of healthcare, transportation, mobile and remote working. While we used to focus on Social Network technology, we have adopted the latest trends and now are actively developing messaging app integrations.</p>'
    //   listheader: 'Lorinthe development service / technology'
    about_us: {
      label: 'about',
      header: {
        title: 'About us',
        subtitle: 'We care',
        lead: 'Happiness | a continuous flow of achievement'
      },
      body: {
        intro: 'Lorinthe BV is a privately owned executive advisory agency.',
        usp: {
          1: 'since 1995',
          2: 'project or time based',
          3: 'fair tariffs',
          4: 'open, agile planning',
          5: 'international experience',
          6: 'proven, hundred+ projects',
          7: 'personal empathy',
          8: 'commercial results'
        }
      },
      specialize: {
        title: 'Specialization',
        slot: 'With over thirty years of hands-on experience we take pride in developing solutions for <i>complex IT relates business problems</i>. We specialize in organizations that deploy <i>digital technology</i>, hardware, software and services, to better serve their clients.'
      },
      // office:
      // title: 'Workplace Philosophy'
      // slot: 'Our workplaces form an ideal combination of serious work and pleasant freedom.'
      // 1:
      //   img: 'workbench.jpg'
      //   type: 'Micro cells'
      //   purpose: 'Efficient, distributed team work'
      //   slot: 'We have a work and location concept that we call "micro-cells". Basically we have teams with three people: two developers and the third being scrum master, tester and UI designer. Lorinthe even specially designed a <b>workbench</b> for our micro cells: three chairs and a large monitor to review work together. Our <b>micro cells</b> are an ideal combination of remote work and team work'
      //   block: 'the people love it: daily commute is minimized while there is still the daily life interaction and structure.'
      // 2:
      //   img: 'groupoffice.jpg'
      //   type: "Group office"
      //   purpose: 'Larger projects & Junior staff / training'
      //   slot: 'We look for places with natural light and an open and pleasant work atmosphere. We like our people to learn from each other first, before they can move on to a micro cell close to their home.'
      //   block: 'natural bright and... always good coffee!'
      management: {
        title: 'Advisors',
        intro: 'Lorinthe\'s leadership team brings decades of extensive industry knowledge and experience, plus a well-rounded business perspective.',
        1: {
          label: 'tom_v',
          name: 'Tom Voorneveld',
          title: 'partner',
          slot: 'With more than 25 years of experience in IT, software development, mobile technology, marketing and sales, Tom has earned his stripes. He has degrees in Business Administration and Technical Computer Science. He founded Lorinthe in 1995 in Amsterdam, The Netherlands. See also: <a href="https://www.linkedin.com/in/tom-voorneveld/" target="_blank">LinkedIn</a>'
        },
        2: {
          label: 'gena_s',
          name: 'Gennadiy Serdyuk',
          title: 'associate',
          slot: 'Gena has almost 30 years of experience in software development and electronics design. His specialization in connected electronics makes him the perfect candidate for Qrespi, intercommunication and the \'Internet of Things\'.  See also: <a href="https://www.linkedin.com/in/gserdyuk/"  target="_blank">LinkedIn</a>'
        }
      }
    },
    blog: {
      label: 'blog',
      title: 'Blog',
      subtitle: 'Stay in touch',
      lead: 'Our biased view on the world of web apps, UI, UX, Linux and much more'
    },
    // career:
    // label: 'career'
    // header:
    //   title: 'Work with us'
    //   subtitle: 'Interface to Care'
    //   lead: 'creation | perfection'
    // intro: 'We are a startup with optimistic and energetic professionals with years of experience. Our goal is to perfect the features and usability of webapps and websites while building a comprehensive product strategy.'
    // vacancies:
    //   title: 'Vacancies'
    //   payload: 'We currently have the following vacancies:'
    // incentive: 'If you feel you could support our vision and are attracted to be part of a highly professional startup in an international playing field'
    // inform: 'please let us know by our contact form'
    // jobs:
    //   label:
    //     tasks: 'tasks'
    //     require: 'he/she should'
    //     location: 'location'
    //   M01:
    //     jobtitle: 'Executive Assistant'
    //     description: 'The backbone of the team'
    //     quote: 'They may not always be at the front-and-center of an organization, but an Executive Assistant is the unsung hero and Chief Efficiency Creator of any team.'
    //     tasks:
    //       1: 'develop and maintain our CRM systems for sales and marketing information'
    //       2: 'manage our daily SCRUM meetings: chairing on-site and online meetings with the development team'
    //       3: 'master our ERP Platform: our \'bread and butter\''
    //       4: 'report sales and marketing progress'
    //       5: 'organize our blogs'
    //       6: 'assist the management in various tasks as requested'
    //       7: 'assist clients by using our platform'
    //       8: 'host (international) events'
    //     require:
    //       1: 'have a strong drive and hands-on mentality'
    //       2: 'excellent English verbal and written skills'
    //       3: 'thriving in an entrepreneurial and self-starting environment'
    //       4: 'be positive, easy going, leveraging your creativity, insight, and intellect.'
    //       5: 'outstanding organization and time management skills, perfectionist'
    //       6: 'the ability to prioritize workload &amp; work on your own initiative'
    //       7: 'open mind; see the world as your playground'
    //       8: 'good representation'
    //     location: 1: 'for our new team in the centre Kiev'
    //     note: ''
    //   U01:
    //     jobtitle: 'User Experience Expert'
    //     description: 'Interfacing the Client'
    //     quote: 'It should look excellent, It must work perfect'
    //     tasks:
    //       1: 'develop User Stories with your own clients'
    //       2: 'manage the account'
    //       3: 'design wireframe layouts for the client\'s apps'
    //       4: 'lead small scrum team as scrum master'
    //       5: 'test the developed software'
    //     require:
    //       1: 'have a strong drive and hands-on mentality'
    //       2: 'excellent English verbal and written skills'
    //       3: 'thriving in an entrepreneurial and self-starting environment'
    //       4: 'be positive, easy going and creative'
    //       5: 'perfectionist'
    //       6: 'good representation'
    //       7: 'experience with Agile / Scrum Teams'
    //       8: 'software testing experience'
    //       9: 'experience with graphical design tools (we use Inkscape)'
    //       10: 'willingness to keep learning'
    //     location: 1: 'for our new team in the centre Kiev'
    //   M02:
    //     jobtitle: 'Marketing Manager'
    //     description: 'The goal getter'
    //     quote: ''
    //     tasks:
    //       1: 'take charge of the Qrespi marketing plan'
    //       2: 'develop and manage our partner/agent channel'
    //       3: 'promote Lorinthe using online tools'
    //       4: 'generate free publicity'
    //       5: 'write promotional blogs'
    //       6: 'organise and maintain our CRM systems for sales and marketing information'
    //       7: 'manage our daily SCRUM meetings: chairing on-site and online meetings with the development team'
    //       8: 'master our Qrespi Platform: our \'bread and butter\''
    //       9: 'report sales and marketing progress'
    //       10: 'test new Qrespi features and report bugs and write up new requirements'
    //     require:
    //       1: 'share our vision'
    //       2: 'be a self starter'
    //       3: 'have a strong sales and marketing drive'
    //       4: 'don\'t take \'no\' for an answer'
    //       5: 'can-do mentality'
    //       6: 'good English'
    //       7: 'proven sales track record'
    //       8: 'thriving in an entrepreneurial and self-starting environment leveraging your creativity, insight, and intt'
    //       9: 'good organization and time management skills'
    //       10: 'work effectively with others but also on your own initiative'
    //     location:
    //       1: 'ability to travel if needed'
    //       2: 'relocate to Kiev or possibly abroad for certain periods of time'
    //       3: 'For our new team in Kiev, close to Metro University or Klovska.'
    //     note: ''
    //   T01:
    //     jobtitle: 'Lead Software Developer'
    //     description: 'Working on your own product to conquer the world'
    //     quote: 'It\'s highly rewarding to develop your own project and be able to focus fully on your own world-class \'baby\'.'
    //     tasks:
    //       1: 'master the development of Lorinthe: both front end backend and server'
    //       2: 'be the proud leader of the technology of a new international, trend-setting product'
    //       3: 'grow and lead the development team along side the success of the company'
    //     require:
    //       1: 'take pride in your own product'
    //       2: 'be willing to learn new technology quickly'
    //       3: 'have a good command of English, so the communication between us is efficient'
    //       4: 'be enthusiastic, honest, full of initiative and flexible'
    //       5: 'be creative and able to come up with great ideas for our future'
    //       6: '5+ years web application development experience'
    //       7: '2+ years JavaScript , HTML5 / SCSS experience'
    //       8: 'understand or quickly master: Vue.js, Node.js, Express, REST, Socket.io, Docker, GIT, RethinkDB'
    //       9: 'we develop our software with Atom on Ubuntu'
    //     location: 1: 'For our team in Kiev, remote work possible.'
    //   T02:
    //     jobtitle: 'Front End Software Developer'
    //     description: 'Work in an international field at your own project'
    //     tasks:
    //       1: 'development software at Lorinthe: mainly front end code'
    //       2: 'be the proud member of the technology of a new international, trend-setting product'
    //       3: 'embrace in the success of the company'
    //     require:
    //       1: 'take pride in your own product'
    //       2: 'be willing to learn new technology quickly'
    //       3: 'have a good command of English, so the communication between us is efficient'
    //       4: 'be enthusiastic, honest, full of initiative and flexible'
    //       5: 'be creative and able to come up with great ideas for our future'
    //       6: '5+ years web application development experience'
    //       7: '2+ years JavaScript , HTML5 / SCSS experience'
    //       8: 'understand or quickly master: Vue.js, Node.js, Express, REST, Socket.io, Docker, GIT, RethinkDB'
    //       9: 'we develop our software with Atom on Ubuntu'
    //     location: 1: 'For our team in Kiev, remote work possible.'
    //   ALL:
    //     jobtitle: 'Working at Lorinthe'
    //     description: 'Apply for a new step in your career'
    //     quote: 'Serious Fun!'
    //     label:
    //       tasks: 'general requirements'
    //       require: 'a plus'
    //       location: 'what we offer you'
    //     tasks:
    //       1: 'sufficient English both verbal as in writing'
    //       2: 'adhering to standards'
    //       3: 'good work-ethics'
    //       4: 'affinity with software, apps, on-line services'
    //       5: 'flexibility in hours when needed (especially applicable if you wor our US clients due to time-zone )'
    //       6: 'be mature and trustworthy'
    //       7: 'have good sense of humour'
    //       8: 'self-starter'
    //     require: 1: 'willingness and ability to travel if needed'
    //     location:
    //       1: 'the thrill to work on your own world-class product'
    //       2: 'an excellent salary'
    //       3: 'bonus structure'
    //       4: 'business trips abroad when needed'
    //       5: 'a warm but very challenging atmosphere'
    //       6: 'English language courses (after 3 months)'
    //       7: 'flexible hours'
    //       8: 'possibility to work from home at times'
    //     note: 'You think you qualify? Contact us and let us know in what job you are interested. Do not forget to tell us why you would like to work for Lorinthe and why you think you are a good addition to our team.'
    footer: {
      copyright: 'copyright ©',
      terms: 'Lorinthe BV, The Netherlands. Our terms and conditions apply to all our services',
      language: 'language',
      is_update: 'There is a new version of this web-app',
      update_now: 'upgrade'
    },
    upgrade: {
      title: 'Upgrade your App',
      header: 'Update and reload',
      intro: 'Any progressive webapp, so also this site, will cache logic and data in your browser. This enables the app to run very fast and when you have no Internet connection. This also means that sometimes an upgrade to a new version can take some time, 24 hours is not unusual. If you do not want to wait that long, you can try to force update by clicking the link below.  <br/><br/>You are now running version ',
      click: 'Force reload'
    },
    not_found: {
      title: 'Sorry, we could not find this page'
    },
    def: {
      yes: 'yes',
      no: 'no',
      send: 'send',
      open: 'open',
      more: 'more',
      close: 'close',
      home: 'home',
      site: 'site',
      introduction: 'Introduction',
      signup: 'Sign up',
      submit: 'Submit',
      reset: 'Reset'
    }
  }
}).call(this)

// # sourceMappingURL=en.js.map
// # sourceURL=coffeescript
